export enum CancelApplicationReason {
  NOT_NOW = 'Now is just not the right time',
  ACCEPTED_ANOTHER_OFFER = 'Accepted another job offer',
  DECIDED_TO_STAY_AT_MY_CURRENT_COMPANY = 'Decided to stay at my current company',
  DONT_WANT_TO_COMPLETE_TT = "Don't want to complete a TT",
  REFUSED_RECORD_VI = 'Refused to record a Video Interview',
  DONT_LIKE_ENGAGEMENT_MODEL = "Don't like the engagement model",
}
